import type { LandingPage } from '@troia-v3/types';
import { DEFAULT_LANDING_PAGE } from '@troia-v3/types';

/**
 * Mapeamento `LandingPage` → path do React Router.
 * Single source of truth pro redirect de home + login.
 */
export const LANDING_PAGE_PATHS: Record<LandingPage, string> = {
  'dashboards-commercial': '/dashboard/management/commercial',
  'dashboards-support': '/dashboard/management/support',
  'dashboards-marketing': '/dashboard/management/marketing',
  'dashboards-analytics': '/dashboard/management/analytics',
  'crm': '/crm',
  // Alias atrelado ao módulo `crm` (ALIAS_LANDING_PAGES no types) — exige crm:read.
  // O ID continua `crm-seller` de propósito: ele está GRAVADO em
  // `levels.landingPage` no banco, e renomeá-lo exigiria migração para ganhar
  // só coerência de nomenclatura interna. O que mudou em 23/08/2026 foi onde a
  // tela mora: "Dashboards > Usuário > Minhas Vendas".
  'crm-seller': '/dashboard/management/sales',
  'chat': '/chat/management',
  // `/tickets` e `/contacts` nunca existiram no router (davam NotFound logo
  // depois do login). Tickets moram no Help Desk; contatos são uma visão do
  // chat. Nenhum nível de produção usava os dois em 20/10/2026.
  'tickets': '/helpdesk/tickets',
  'calendar': '/calendar',
  'contacts': '/chat',
  // Rota livre — não exige permissão de módulo (ver FREE_LANDING_PAGES no types).
  'checklists-my': '/checklists/my',
};

/**
 * Resolve o path destino do redirect baseado no landingPage do level.
 * Se undefined, usa `DEFAULT_LANDING_PAGE` como fallback.
 */
export function getLandingPagePath(landingPage: LandingPage | undefined): string {
  const target = landingPage ?? DEFAULT_LANDING_PAGE;
  return LANDING_PAGE_PATHS[target];
}
